import Envios from "../views/modulos/envios/List.vue";
import FormEnvios from "../views/modulos/envios/Form.vue";
const VarRutasEnvio=[
    {
        path: '/Envios',
        name: 'envios',
        component: Envios,
        props: true
    },
    {
        path: '/EnviosForm',
        name: 'FormEnvio',
        component: FormEnvios,
        props: true
    }
];
export default {
    VarRutasEnvio,
}